module.exports = __webpack_public_path__ + "static/img/13.e6dddbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/13.jpg
// module id = 8C60
// module chunks = 16